import layoutHeaderAside from '@/layouts/HeaderAside'
const meta = { auth: true }
export default {
  path: '/shipmentBusiness',
  meta,
  component: layoutHeaderAside,
  children: [
    {
      path: '/shipmentBusiness',
      name: 'shipmentBusiness',
      component: () => import('@/pages/shipmentBusiness/intlPeriodApply.vue'),
      meta: {
        ...meta,
        title: '发货',
        requireAuth: true
      }
    },
    {
      path: '/shipmentBusiness/intlPeriodApply',
      name: 'intlPeriodApply',
      props: true,
      component: () => import('@/pages/shipmentBusiness/phaseTransportDemandNew.vue'),
      meta: {
        ...meta,
        title: '月需求提报',
        requireAuth: true
      }
    },
    {
      path: '/shipmentBusiness/dayDemandApply',
      name: 'dayDemandApply',
      component: () => import('@/pages/shipmentBusiness/dayDemandApply.vue'),
      meta: {
        ...meta,
        title: '日需求提报',
        requireAuth: true
      }
    },
    {
      path: '/shipmentBusiness/zlydApply',
      name: 'zlydApply',
      props: true,
      component: () => import('@/pages/shipmentBusiness/zlydApply.vue'),
      meta: {
        ...meta,
        title: '国际运单填报',
        requireAuth: true
      }
    },
    {
      path: '/shipmentBusiness/zlydApply-ColdChainTransport',
      name: 'zlydApply-ColdChainTransport',
      props: true,
      component: () => import('@/pages/shipmentBusiness/zlydApply-ColdChainTransport.vue'),
      meta: {
        ...meta,
        title: '国际运单填报-冷链运输',
        requireAuth: true
      }
    },
    {
      path: '/shipmentBusiness/emptyVanBook',
      name: 'emptyVanBook',
      component: () => import('@/pages/shipmentBusiness/emptyVanBook.vue'),
      meta: {
        ...meta,
        title: '铁路箱预定',
        requireAuth: true
      }
    },
    {
      path: '/shipmentBusiness/emptyVanBook-ColdChainTransport',
      name: 'emptyVanBook-ColdChainTransport',
      component: () => import('@/pages/shipmentBusiness/emptyVanBook-ColdChainTransport.vue'),
      meta: {
        ...meta,
        title: '铁路箱预定-冷链运输',
        requireAuth: true
      }
    },
    {
      path: '/shipmentBusiness/waybillFill',
      name: 'waybillFill',
      component: () => import('@/pages/shipmentBusiness/waybillFill.vue'),
      meta: {
        ...meta,
        title: '自备箱发货',
        requireAuth: true
      }
    },
    {
      path: '/shipmentBusiness/waybillFill-ColdChainTransport',
      name: 'waybillFill-ColdChainTransport',
      component: () => import('@/pages/shipmentBusiness/waybillFill-ColdChainTransport.vue'),
      meta: {
        ...meta,
        title: '自备箱发货-冷链运输',
        requireAuth: true
      }
    },
    {
      path: '/shipmentBusiness/containerLoading',
      name: 'containerLoading',
      component: () => import('@/pages/shipmentBusiness/containerLoading.vue'),
      meta: {
        ...meta,
        title: '装箱',
        requireAuth: true
      }
    },
    {
      path: '/shipmentBusiness/containerDayDemand',
      name: 'containerDayDemand',
      component: () => import('@/pages/shipmentBusiness/containerDayDemand/index.vue'),
      meta: {
        ...meta,
        title: '提出日需求',
        requireAuth: true
      }
    },
    {
      path: '/shipmentBusiness/oneClickDelivery',
      name: 'oneClickDelivery',
      component: () => import('@/pages/shipmentBusiness/oneClickDelivery/index.vue'),
      meta: {
        ...meta,
        title: '一键发货',
        // requireAuth: true
      }
    },
  ]
}
